import { render } from "./shareResult.vue?vue&type=template&id=36f02dcb&scoped=true"
import script from "./shareResult.vue?vue&type=script&lang=js"
export * from "./shareResult.vue?vue&type=script&lang=js"

import "./shareResult.vue?vue&type=style&index=0&id=36f02dcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f02dcb"]])

export default __exports__